import axios from 'axios'

// Get all customers for admin
const getAll = async (iniDate, endDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/customer/admin/${iniDate}/${endDate}`)
  return data
}

const update = async (
  user,
  name,
  email,
  phone,
  cpf,
  telegram,
  traddingview,
  fonte
) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/customer/admin/user`, {
    user,
    name,
    email,
    phone,
    cpf,
    telegram,
    traddingview,
    fonte
  })
  return data
}

export {
  getAll,
  update
}
